// extracted by mini-css-extract-plugin
export default {"wrapper":"ayOxUM","placeholderWrapper":"byOxUM","placeholderHidden":"cyOxUM"};